import { createAction, props } from '@ngrx/store';
import { DeliveryNote, DeliveryNotesOverview, DeliveryNotesOverviewRequest } from 'src/app/uig-my-account/delivery-notes/delivery-notes.models';

// *****************************************************

export const getDeliveryNotesOverview = createAction(
  '[Delivery Notes] get delivery notes overview',
  props<{
    formData: DeliveryNotesOverviewRequest;
  }>()
);

export const getMarketplaceDeliveryNotesOverview = createAction(
  '[Marketplace Delivery Notes] get delivery notes overview',
  props<{
    formData: DeliveryNotesOverviewRequest;
  }>()
);

export const getDeliveryNotesOverviewSuccess = createAction(
    '[Delivery Notes] get delivery notes overview success',
  props<{ overview: DeliveryNotesOverview }>()
);

export const getDeliveryNotesOverviewFailure = createAction(
    '[Delivery Notes] get delivery notes overview failure',
  props<{ error: Error }>()
);

// *****************************************************

export const clearDeliveryNotesOverview = createAction(
  '[Delivery Notes] clear delivery notes overview'
);

// *****************************************************

export const getDeliveryNote = createAction(
  '[Delivery Notes] get delivery note',
  props<{
    uigDeliveryNumber: string;
  }>()
);

export const getMarketplaceDeliveryNote = createAction(
  '[Marketplace Delivery Notes] get delivery note',
  props<{
    uigDeliveryNumber: string;
  }>()
);

export const getDeliveryNoteSuccess = createAction(
    '[Delivery Notes] get delivery note success',
  props<{ deliveryNote: DeliveryNote }>()
);

export const getDeliveryNoteFailure = createAction(
    '[Delivery Notes] get delivery note  failure', 
  props<{ error: Error }>()
);

